import React from 'react';
import { Link } from 'react-router-dom';
import { Home } from 'lucide-react';
import { Button } from '../components/ui/button';

const NotFoundPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full text-center">
        {/* 404 Number */}
        <h1 className="text-8xl font-bold text-gray-200 mb-4">404</h1>

        {/* Message */}
        <h2 className="text-xl font-semibold text-gray-900 mb-2">
          Page Not Found
        </h2>
        <p className="text-sm text-gray-600 mb-8">
          The page you're looking for doesn't exist.
        </p>

        {/* Single CTA */}
        <Link to="/">
          <Button
            style={{ backgroundColor: '#2563EB' }}
            className="inline-flex items-center gap-2 text-white hover:opacity-90"
          >
            <Home className="w-4 h-4" />
            Back to Home
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default NotFoundPage;
